import { render, staticRenderFns } from "./callsModal.vue?vue&type=template&id=6f22a101&scoped=true&"
import script from "./callsModal.vue?vue&type=script&lang=js&"
export * from "./callsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f22a101",
  null
  
)

export default component.exports